<template>
  <div class="comment-list">
    <div class="list-header">
      <h2>评论管理</h2>
      <div class="header-right">
        <el-select v-model="articleFilter" placeholder="筛选文章" clearable style="width: 200px; margin-right: 10px;">
          <el-option label="全部文章" value=""></el-option>
          <el-option v-for="article in articles" :key="article.id" :label="article.title" :value="article.id"></el-option>
        </el-select>
        <el-input v-model="keyword" placeholder="搜索评论内容" size="small" clearable prefix-icon="el-icon-search" style="width: 240px; margin-right: 10px;" @keyup.enter.native="handleSearch" @clear="handleSearch"></el-input>
        <el-select v-model="statusFilter" placeholder="筛选状态" style="width: 120px; margin-right: 10px;">
          <el-option label="全部" value="all"></el-option>
          <el-option label="待审核" value="pending"></el-option>
          <el-option label="已通过" value="approved"></el-option>
          <el-option label="已屏蔽" value="blocked"></el-option>
        </el-select>
        <el-button size="small" icon="el-icon-search" @click="handleSearch">查询</el-button>
      </div>
    </div>
    <el-table :data="comments" border>
      <el-table-column prop="id" label="ID"></el-table-column>
      <el-table-column prop="articleTitle" label="文章标题">
        <template slot-scope="scope">
          <a :href="`/article/${scope.row.articleId}`" target="_blank">{{ scope.row.articleTitle }}</a>
        </template>
      </el-table-column>
      <el-table-column prop="content" label="评论内容"></el-table-column>
      <el-table-column prop="username" label="评论者"></el-table-column>
      <el-table-column prop="status" label="状态">
        <template slot-scope="scope">
          <el-tag :type="getStatusType(scope.row.status)">{{ getStatusText(scope.row.status) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="createdAt" label="评论时间"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button v-if="scope.row.status === 'pending'" size="small" type="success" @click="approveComment(scope.row.id)">通过</el-button>
          <el-button v-if="scope.row.status !== 'blocked'" size="small" type="danger" @click="blockComment(scope.row.id)">屏蔽</el-button>
          <el-button size="small" type="danger" @click="deleteComment(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-sizes="[10, 20, 50]"
      :page-size="size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
  </div>
</template>

<script>
import { getComments, approveComment, blockComment, deleteComment, getArticles } from '@/api/blog'

export default {
  name: 'CommentList',
  data() {
    return {
      comments: [],
      articles: [],
      page: 1,
      size: 10,
      total: 0,
      statusFilter: 'all',
      keyword: '',
      articleFilter: ''
    }
  },
  mounted() {
    this.loadArticles()
    this.loadComments()
  },
  methods: {
    async loadArticles() {
      const res = await getArticles(0, 1000, '')
      this.articles = res.data.content
    },
    async loadComments() {
      const articleId = this.articleFilter ? this.articleFilter : null
      const res = await getComments(this.page - 1, this.size, this.statusFilter, this.keyword, articleId)
      this.comments = res.data.content
      this.total = res.data.totalElements
    },
    handleSearch() {
      this.page = 1
      this.loadComments()
    },
    handleSizeChange(val) {
      this.size = val
      this.loadComments()
    },
    handleCurrentChange(val) {
      this.page = val
      this.loadComments()
    },
    getStatusType(status) {
      const types = {
        'pending': 'warning',
        'approved': 'success',
        'blocked': 'danger'
      }
      return types[status] || 'info'
    },
    getStatusText(status) {
      const texts = {
        'pending': '待审核',
        'approved': '已通过',
        'blocked': '已屏蔽'
      }
      return texts[status] || status
    },
    async approveComment(id) {
      await approveComment(id)
      this.loadComments()
      this.$message.success('审核通过')
    },
    async blockComment(id) {
      await blockComment(id)
      this.loadComments()
      this.$message.success('已屏蔽')
    },
    async deleteComment(id) {
      if (confirm('确定要删除这条评论吗？')) {
        await deleteComment(id)
        this.loadComments()
        this.$message.success('删除成功')
      }
    }
  },
  watch: {
    statusFilter() {
      this.page = 1
      this.loadComments()
    },
    articleFilter() {
      this.page = 1
      this.loadComments()
    }
  }
}
</script>

<style scoped>
.comment-list {
  padding: 20px;
}

.list-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
</style>
